/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const isDeployedToProductionEndpoint =
  window.location.hostname === 'restaurant-manager24.hssoft.com'

const awsmobile = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id: 'eu-west-1:46ef19b7-823a-4c10-a0a6-fa23d303688e',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_ZQAKufUVZ',
  aws_user_pools_web_client_id: '1t2j35i84uj8ekvr29np02n9k7',
  oauth: {
    domain: 'hssoft.auth.eu-west-1.amazoncognito.com',
    scope: ['email', 'openid', 'phone'],
    redirectSignIn: 'http://localhost:3000,https://qr-admin.hssoft.com',
    redirectSignOut: 'http://localhost:3000,https://qr-admin.hssoft.com',
    responseType: 'code'
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['TOTP'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: ['REQUIRES_LOWERCASE', 'REQUIRES_NUMBERS', 'REQUIRES_SYMBOLS']
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  cookieStorage: {
    domain: isDeployedToProductionEndpoint ? '.hssoft.com' : window.location.hostname,
    secure: isDeployedToProductionEndpoint
  }
}

export default awsmobile
